import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-67b8ebf0"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["id"];
const _hoisted_2 = ["id"];
const _hoisted_3 = { class: "h-[8rem] relative px-3 flex flex-col items-center" };
const _hoisted_4 = { class: "bg-[#f4ebff] w-11 h-11 rounded-full p-[6px]" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "bg-primary-600 w-3 h-3 rounded-full border-primary-600 border-2" }, null, -1 /* HOISTED */));
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "border-[1px] border-l-[0.2px] border-primary-600 rounded-full min-h-[100px] h-auto w-[1px]" }, null, -1 /* HOISTED */));
const _hoisted_7 = { class: "flex flex-col w-[9rem] mt-[10px]" };
const _hoisted_8 = ["id"];
const _hoisted_9 = ["id"];
const _hoisted_10 = ["id"];
const _hoisted_11 = ["id"];
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "border-[1px] border-l-[0.2px] border-gray-200 mx-3 rounded-full h-[95px]" }, null, -1 /* HOISTED */));
const _hoisted_13 = { class: "flex flex-col" };
const _hoisted_14 = ["id"];
const _hoisted_15 = { key: 0 };
const _hoisted_16 = { class: "font-semibold" };
const _hoisted_17 = {
    key: 0,
    class: "flex flex-col gap-[2px] mt-1"
};
const _hoisted_18 = {
    key: 0,
    class: "text-[#475467] w-[3.5rem] font-semibold"
};
const _hoisted_19 = {
    key: 1,
    class: "capitalize font-normal"
};
const _hoisted_20 = ["id"];
import FieldDetailsModal from '@/components/common/FieldDetailsModal.vue';
import { convertAndFormatSource } from '@/helper/helper';
import moment from 'moment-timezone';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ActivityTimeline',
    props: {
        changeLabel: String,
        createdAt: String,
        from: String,
        to: String,
        source: String,
        userName: String,
        filterOption: String,
        fields: Object,
        type: String,
        currentValues: Object,
        timezone: String,
        index: Number,
    },
    setup(__props) {
        const props = __props;
        const { t } = useI18n();
        const additionalDetails = ref(false);
        const data = ref('');
        const createdAtDay = computed(() => {
            return moment(props === null || props === void 0 ? void 0 : props.createdAt).tz(props === null || props === void 0 ? void 0 : props.timezone).format('DD MMM YYYY');
        });
        const createdAtTime = computed(() => {
            return moment(props === null || props === void 0 ? void 0 : props.createdAt).tz(props === null || props === void 0 ? void 0 : props.timezone).format('hh:mm A');
        });
        const sourceMap = {
            event_sync: 'Sync',
            web_app: 'Web App',
        };
        // Function to open the details modal on click on View Details
        const openDetailsModal = details => {
            data.value = details;
            additionalDetails.value = !additionalDetails.value;
        };
        // Function to close the details modal
        const cancelDetailsModal = () => {
            additionalDetails.value = !additionalDetails.value;
            data.value = '';
        };
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e;
            return (_openBlock(), _createElementBlock("div", null, [
                (!__props.filterOption || (__props.filterOption && ((_a = __props.fields) === null || _a === void 0 ? void 0 : _a.includes(__props.filterOption))))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        id: `activity-timline${__props.index}-container`,
                        class: "timelineMainContainer"
                    }, [
                        _createCommentVNode(" Left part of the timeline: Vertical line and date/source information "),
                        _createElementVNode("div", {
                            class: "flex flex-row gap-2 w-[40%]",
                            id: `activity-timeline-left-container${__props.index}`
                        }, [
                            _createElementVNode("div", _hoisted_3, [
                                _createCommentVNode(" Circle indicating the timeline event "),
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("div", {
                                        class: "bg-primary-50 w-8 h-8 rounded-full border-primary-600 p-[9px]",
                                        style: _normalizeStyle({ borderWidth: __props.index === 0 ? '1px ' : '0px' })
                                    }, [
                                        _createCommentVNode(" Inner circle with a colored dot "),
                                        _hoisted_5
                                    ], 4 /* STYLE */)
                                ]),
                                _createCommentVNode(" Vertical line connecting the circle to the bottom "),
                                _hoisted_6
                            ]),
                            _createCommentVNode(" Date and source information "),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", {
                                    id: `activity-created-day${__props.index}`,
                                    class: "text-gray-700 font-medium capitalize"
                                }, _toDisplayString(createdAtDay.value), 9 /* TEXT, PROPS */, _hoisted_8),
                                _createElementVNode("div", {
                                    class: "text-gray-500 text-[13px] font-normal py-[2px]",
                                    id: `activity-created-time${__props.index}`
                                }, _toDisplayString(createdAtTime.value), 9 /* TEXT, PROPS */, _hoisted_9),
                                _createCommentVNode(" Display the source in capitalized form "),
                                _createElementVNode("div", {
                                    class: "text-gray-600 font-semibold capitalize",
                                    id: `activity-source${__props.index}`
                                }, _toDisplayString((_b = (sourceMap[`${_unref(convertAndFormatSource)(__props.source)}`] || __props.source)) === null || _b === void 0 ? void 0 : _b.replaceAll('_', ' ')), 9 /* TEXT, PROPS */, _hoisted_10)
                            ])
                        ], 8 /* PROPS */, _hoisted_2),
                        _createCommentVNode(" Right part of the timeline: Activity details "),
                        _createElementVNode("div", {
                            class: "flex flex-row pt-1 w-[60%] h-[120px] items-center",
                            id: `activity-timeline-right-container${__props.index}`
                        }, [
                            _hoisted_12,
                            _createElementVNode("div", _hoisted_13, [
                                _createCommentVNode(" If a user name exists, display \"by\" and the user's name "),
                                _createElementVNode("div", {
                                    class: "capitalize",
                                    id: `activity-performed-by${__props.index}`
                                }, [
                                    _createTextVNode(_toDisplayString(__props.changeLabel) + " ", 1 /* TEXT */),
                                    (__props.userName)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                            _createTextVNode("by "),
                                            _createElementVNode("span", _hoisted_16, _toDisplayString(__props.userName), 1 /* TEXT */)
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ], 8 /* PROPS */, _hoisted_14),
                                _createCommentVNode(" If the filter option is not 'google' or 'outlook', display the update label and value "),
                                ((__props.changeLabel !== 'Created' &&
                                    __props.type !== 'upload' &&
                                    __props.type !== 'download' &&
                                    ((_c = __props.fields) === null || _c === void 0 ? void 0 : _c.length) === 1) ||
                                    (__props.filterOption && ((_d = __props.fields) === null || _d === void 0 ? void 0 : _d.includes(__props.filterOption))))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                        (__props.filterOption !== 'google' && __props.filterOption !== 'outlook')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, " Update: "))
                                            : _createCommentVNode("v-if", true),
                                        (__props.filterOption !== 'google' && __props.filterOption !== 'outlook')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(__props.to || __props.currentValues[__props.filterOption]), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true)
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                _createCommentVNode(" Show View Details button if the label is 'created' "),
                                (__props.changeLabel === 'Created' || ((_e = __props.fields) === null || _e === void 0 ? void 0 : _e.length) > 1)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        id: `view-details-button${__props.index}`,
                                        class: "bg-blue-100 text-blue-500 w-28 text-center rounded-md cursor-pointer mt-2",
                                        onClick: _cache[0] || (_cache[0] = () => openDetailsModal(__props.currentValues))
                                    }, _toDisplayString(_unref(t)('activity_log.view_details')), 9 /* TEXT, PROPS */, _hoisted_20))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ], 8 /* PROPS */, _hoisted_11)
                    ], 8 /* PROPS */, _hoisted_1))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" Show the below modla only if the additionalDetails flag is true "),
                _createVNode(FieldDetailsModal, {
                    "show-modal": additionalDetails.value,
                    "on-cancel-click": cancelDetailsModal,
                    data: data.value,
                    title: _unref(t)('activity_log.add_update_fields')
                }, null, 8 /* PROPS */, ["show-modal", "data", "title"])
            ]));
        };
    }
});
